export const classes = {
  card: 'flex transition-all duration-100 py-3 pl-3 pr-1 mb-2 mx-2 w-full border border-white dark:border-[#332e43] hover:border-orange-3 bg-white dark:bg-[#332e43]',
  itemIconWrapper: 'mr-4',
  content: 'grow min-w-0',
  optionsWrapper: 'flex justify-center items-start ml-3 mr-1',
  optionsIcon: 'options-icon cursor-pointer text-taupe-2 dark:text-mauve-2',
};

export const styles = {
  card: {
    '& .options-icon': {
      width: 0,
      transition: 'width 0.2s',
    },
    '&:hover .options-icon': {
      width: 24,
    },
  },
};
